import { PieMeta } from './models';

export const convert = (object: {}, meta: PieMeta) => {
  if (!object) return { series: [] };
  return {
    series: [
      {
        data: meta.slices
          .map((item) => ({ value: object[item.key], name: item.title, key: item.key }))
          .filter((item) => item.value !== undefined && item.value !== null),
      },
    ],
  };
};
